// extracted by mini-css-extract-plugin
module.exports = {"navigation":"mainnav-module--navigation--A85EX"};